import { http } from './http'

export function getKitchenOrderByContractorDate(contractorId, date) {
  return http.get(`/api/kitchen/orders/${contractorId}/${date}`)
}

export function setKitchenMealQty(contractorId, date, meal, qty) {
  return http.put(`/api/kitchen/orders/${contractorId}/${date}/meals/${meal}`, { qty })
}

export function setKitchenOrderComment(contractorId, date, comment) {
  return http.put(`/api/kitchen/orders/${contractorId}/${date}/comment`, { comment })
}

export function setKitchenOrderSpecialQty(contractorId, date, meal, specialTypeId, qty) {
  return http.put(`/api/kitchen/orders/${contractorId}/${date}/specials/${meal}/${specialTypeId}`, { qty })
}

export function addKitchenChildToMeal(contractorId, date, childId, meal, note = null) {
  return http.post(`/api/kitchen/orders/${contractorId}/${date}/children/${childId}/${meal}`, { note })
}

export function removeKitchenChildFromMeal(contractorId, date, childId, meal) {
  return http.delete(`/api/kitchen/orders/${contractorId}/${date}/children/${childId}/${meal}`)
}
